<div class="container-fluid ptCustom">

    <div class="row mt-4 dashboardWrap">



        <!-- main -->
        <div class="col-lg-8">

            <!-- welcome -->
            <div class="card shadow-sm rounded-lg welcomeCard">
                <div class="card-body p-4">
                    <div class="wMsg mb-3">
                        <span class="wIcon"><i class="fa-solid fa-star"></i></span>
                        <span class="wInterject">Hey,</span>
                        <span class="wUser">{{userFirstName}}!</span>
                    </div>
                    <p class="wText mb-0">
                        Welcome to your member dashboard! Take some time to review the information on your landing page.
                    </p>
                </div>
            </div>

            <!-- stats and cta -->
            <div class="card shadow-sm rounded-lg" *ngIf="membershipLevel != 'HealthAlliance'">
                <div class="card-body p-3">
                    <div class="detailsHeader">
                        <h4><span class="iconS"><i class="fa-regular fa-chart-simple"></i></span>Membership Usage</h4>
                    </div>
                    <div class="row g-2">
                        <div class="col-md">
                            <div class="detailsSection dashboardStat">
                                <div class="statCall">
                                    <span class="statNo">
                                        {{info.newsSubmittedThisYear}}
                                    </span>
                                    <span class="statIcon green">
                                        <i class="fa-regular fa-newspaper"></i>
                                    </span>
                                </div>
                                <div class="statDesc">
                                    news submissions this year
                                </div>
                                <div class="statPending">
                                    {{info.pendingNewsSubmissions}} pending
                                </div>
                                <a [routerLink]="['/admin-portal/member/submit-member-news']" class="statCta">submit news <span class="ctaIcon"><i class="fa-regular fa-angle-right"></i></span></a>
                            </div>
                        </div>
                        <div class="col-md" *ngIf="hasLetterOfIntroPerk">
                            <div class="detailsSection dashboardStat">
                                <div class="statCall">
                                    <span class="statNo">
                                        {{info.lettersOfIntroUsed}}/{{info.lettersOfIntroAllowed}}
                                    </span>
                                    <span class="statIcon purple">
                                        <i class="fa-regular fa-handshake"></i>
                                    </span>
                                </div>
                                <div class="statDesc">
                                    letters of introduction used
                                </div>
                                <div class="statPending">
                                    {{info.pendingLettersOfIntroduction}} pending
                                </div>
                                <a [routerLink]="['/public/member-directory']" class="statCta">member directory <span class="ctaIcon"><i class="fa-regular fa-angle-right"></i></span></a>
                            </div>
                        </div>
                        <div class="col-md" *ngIf="hasAds">
                            <div class="detailsSection dashboardStat">
                                <div class="statCall">
                                    <span class="statNo">
                                        {{info.adsSubmittedThisYear}}
                                    </span>
                                    <span class="statIcon blue">
                                        <i class="fa-regular fa-ad"></i>
                                    </span>
                                </div>
                                <div class="statDesc">
                                    ads submitted this year
                                </div>
                                <div class="statPending">
                                    {{info.pendingAds}} pending
                                </div>
                                <a [routerLink]="['/admin-portal/member/member-ads']" class="statCta">submit ad <span class="ctaIcon"><i class="fa-regular fa-angle-right"></i></span></a>
                            </div>
                        </div>
                        </div>

                    </div>
            </div>

            <!-- chamber news -->
            <!--<div class="card shadow-sm rounded-lg" *ngIf="membershipLevel != 'HealthAlliance'">
                <div class="card-body p-3">
                    <div class="detailsHeader">
                        <h4><span class="iconS"><i class="fa-regular fa-memo"></i></span>Chamber News</h4>
                    </div>
                    <div class="row g-2">
                        <div class="col-lg-8">
                            <div class="detailsSection">
                                text
                            </div>
                        </div>

                        <div class="col-lg-4">
                            <div class="detailsSection">
                                add news
                            </div>
                        </div>
                    </div>
                </div>
            </div>-->

            

        </div>




        <!-- right -->
        <div class="col-lg-4">

            <!-- benefits -->
            <div class="card shadow-sm rounded-lg">
                <div class="card-body p-3">

                    <div class="detailsHeader">
                        <h4><span class="iconS"><i class="fa-regular fa-treasure-chest"></i></span>Membership Benefits</h4>
                    </div>
                    
                    <div class="benefitWrap">

                        <div class="benefitDiv">
                            <div class="benefitIcon purple">
                                <i class="fa-solid fa-calendar-star"></i>
                            </div>
                            <div class="benefitDesc">
                                <div class="benefitTitle">
                                    Events &amp; Networking
                                </div>
                                Your membership grants you access to Indy Chamber events. Come look at our various topics and focuses, and register today!
                            </div>
                            <a class="benefitBtn" target="_blank" href="https://indychamber.com/attend-an-event/">
                                <i class="fa-solid fa-angle-right"></i>
                            </a>
                        </div>

                        <div class="benefitDiv">
                            <div class="benefitIcon purple">
                                <i class="fa-solid fa-book"></i>
                            </div>
                            <div class="benefitDesc">
                                <div class="benefitTitle">
                                    Resource Program &amp; Savings
                                </div>
                                There are many digital benefits available to you as an Indy Chamber Member. Click here to explore your resources!
                            </div>
                            <a class="benefitBtn" target="_blank" [routerLink]="['/public/resources']" href="javascript:void(0);">
                                <i class="fa-solid fa-angle-right"></i>
                            </a>
                        </div>

                        <div class="benefitDiv">
                            <div class="benefitIcon teal">
                                <i class="fa-solid fa-ticket"></i>
                            </div>
                            <div class="benefitDesc">
                                <div class="benefitTitle">
                                    Exclusive Discounts
                                </div>
                                Explore discounts offered by Indy Chamber members, for Indy Chamber members.
                            </div>
                            <a class="benefitBtn" target="_blank" href="javascript:void(0);" [routerLink]="['/public/member-discounts']">
                                <i class="fa-solid fa-angle-right"></i>
                            </a>
                        </div>

                        <div class="benefitDiv">
                            <div class="benefitIcon pink">
                                <i class="fa-solid fa-money-bill-transfer"></i>
                            </div>
                            <div class="benefitDesc">
                                <div class="benefitTitle">
                                    Lending and Capital
                                </div>
                                We offer loans and financing unavailable through traditional lenders. With amounts ranging from $1,000 to $50,000+, we have you covered, whatever you need.
                            </div>
                            <a class="benefitBtn" target="_blank" href="https://indychamber.com/entrepreneur-services/lending/">
                                <i class="fa-solid fa-angle-right"></i>
                            </a>
                        </div>

                        <div class="benefitDiv">
                            <div class="benefitIcon blue">
                                <i class="fa-solid fa-megaphone"></i>
                            </div>
                            <div class="benefitDesc">
                                <div class="benefitTitle">
                                    Engagement
                                </div>
                                Interested in getting more engaged through volunteerism? Learn more about it here!
                            </div>
                            <a class="benefitBtn" target="_blank" href="https://indychamber.com/engage/">
                                <i class="fa-solid fa-angle-right"></i>
                            </a>
                        </div>
                    </div>

                </div>
            </div>


            <!-- help -->
            <div class="card shadow-sm rounded-lg">
                <div class="card-body p-3">

                    <div class="detailsHeader">
                        <h4><span class="iconS"><i class="fa-regular fa-circle-question"></i></span>Need Help?</h4>
                    </div>
                    
                    <div class="benefitWrap">

                        <!--<div class="benefitDiv">
                            <div class="benefitIcon help">
                                <i class="fa-regular fa-comments-question"></i>
                            </div>
                            <div class="benefitDesc">
                                <div class="benefitTitle">
                                    Member FAQ
                                </div>
                            </div>
                            <a class="benefitBtn" href="javascript:void(0);">
                                <i class="fa-solid fa-angle-right"></i>
                            </a>
                        </div>-->

                        <div class="benefitDiv">
                            <div class="benefitIcon help">
                                <i class="fa-regular fa-comments-question"></i>
                            </div>
                            <div class="benefitDesc">
                                <div class="benefitTitle">
                                    Need Direct Assistance?
                                </div>
                                <a href="mailto:memberservices@indychamber.com">memberservices&#64;indychamber.com</a>
                            </div>
                            <a class="benefitBtn" href="mailto:memberservices@indychamber.com">
                                <i class="fa-solid fa-angle-right"></i>
                            </a>
                        </div>

                        

                    </div>

                </div>
            </div>


        </div>




    </div>

    
      






    

</div>